import { OnInit, Component, ViewChild } from '@angular/core';
import { SearchFilter, IFilterResponse } from '../../../../infrastructure/iFilter-component';
import { MatTableDataSource, MatSort } from '@angular/material';
import { SearchCompleteFilterComponent } from '../../../controls/search-complete-filter/search-complete-filter.component';
import { Router } from '@angular/router';
import { MenuService } from '../../../../services/menu.service';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { PagerControlComponent } from '../../../controls/pager/pager-control.component';
import { LogisticsService } from '../../../../services/logistics.service';
import { ConfirmDialogService } from '../../../../services/confirm-dialog.service';
import { StudyReportBatch } from '../../../../model/logistics/study-report/index';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-send-study-report-logistics-search',
  templateUrl: './send-study-report-logistics-search.component.html',
  styleUrls: ['./send-study-report-logistics-search.component.css']
})
export class SendStudyReportLogisticsSearchComponent implements OnInit {

  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  displayedColumns: string[] = ['name', 'star'];
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchCompleteFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor(
    private router: Router
    , private menuService: MenuService
    , private authService: AuthService
    , private logisticsService: LogisticsService
    , private confirmDialogService: ConfirmDialogService
    , private notificationToastService: NotificationToastService) {
    this.menuService.setMenuTitle('Logística', 'envío de informes');
  }

  ngOnInit(): void {

  }

  async studyReportBatchDelete(studyReportBatch: StudyReportBatch) {
    this.confirmDialogService.confirm('Envio de informes'
      , 'Está seguro que desea deshabilitar?', 'Sí', 'No').subscribe(async (value) => {
        try {
          if (value && studyReportBatch.CanEdit) {
            this.loading = true;
            await this.logisticsService.studyReportBatchDelete(studyReportBatch);
            await this.searchFilter.search();
          }
        } catch (err) {
          this.notificationToastService.error(JSON.stringify(err.error), 'Envio de informes');
        } finally {
          this.loading = false;
        }
      });
  }
 
  rollBackStudyReportBach(studyReportBatch: StudyReportBatch): void {
    if (!studyReportBatch.CanEdit) {
      this.confirmDialogService.confirm('Revertir lote'
      , 'Está seguro que desea revertir el lote?', 'Sí', 'No').subscribe(async (value) => {
        if (value) {
          try {
            this.loading = true;
            await this.logisticsService.studyReportBatchRollBack(studyReportBatch, this.authService.getSectorId());
            await this.searchFilter.search();
          } catch (err) {
            this.notificationToastService.error(JSON.stringify(err), 'Envio de informes');
          } finally {
            this.loading = false;
          }
        }
      });
    }
  }

  async studyReportBatchEnable(studyReportBatch: StudyReportBatch) {
    try {
      if (studyReportBatch.Deleted) {
        this.loading = true;
        await this.logisticsService.studyReportBatchEnable(studyReportBatch);
        await this.searchFilter.search();
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Envio de informes');
    } finally {
      this.loading = false;
    }
  }

  editStudyReportBach(studyReportBatch: StudyReportBatch): void {
    if (studyReportBatch.CanEdit) {
      this.router.navigate(['send-study-report-logistics-wizard', studyReportBatch.Id]);
    }
  }

  newStudyReportBach(): void {
    this.router.navigate(['send-study-report-logistics-wizard']);
  }

  onStartSearch(): void {
    this.loading = true;
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<StudyReportBatch>): void {
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
  }
}
